import {usePromotion} from '@/context/Promotion/PromotionContext'
import {DiscountReward, PromotionCondition, rewardTypeToIdMap} from '@/types/promotion'
import {RewardTypes} from '@/utils/constants/promotionConstants'

type UseRewardItemArgs = {
  promotionCondition: PromotionCondition
  rewardIndex?: number
}

export const useRewardItem = ({promotionCondition, rewardIndex = 0}: UseRewardItemArgs) => {
  const {promotion, setMaxDiscountModalVisible, onResultChange, promotionConfig, updatePromotion} = usePromotion()
  const {maxDiscountPercentage, conditions} = promotionConfig
  const rewardOptions = conditions?.rewardTypeOptions?.map(option => ({
    displayText: option.label,
    id: option.value,
    discountType: option.discountType || option.rewardType,
    rewardType: option.rewardType,
  }))

  const selectedReward = promotion?.promotionConditions?.[0]?.rewards?.[rewardIndex]
  const rewardType =
    rewardTypeToIdMap?.[selectedReward?.type || '']?.[selectedReward?.discountType || ''] || selectedReward?.type || ''
  const rewardValue = rewardOptions?.filter(item => item.id === rewardType)

  const handleDeleteLayer = () => {
    const updatedConditions = promotion?.promotionConditions?.filter(
      condition => condition.sequence !== promotionCondition?.sequence
    )
    onResultChange({promotionConditions: updatedConditions})
  }

  const handleSelectedRewardItem = (value: any) => {
    if (!value || !value.length) return
    const selected = value[0]

    updatePromotion((prev: any) => ({
      ...prev,
      promotionConditions: prev?.promotionConditions?.map(condition => {
        // Individual rewards must all share the first reward's type, so every reward of the layer follows it
        const rewards = condition?.rewards ?? []
        return {
          ...condition,
          rewards: Array.from({length: Math.max(rewards.length, 1)}, () => ({
            type: selected.rewardType,
            items: [],
            discountType: selected.discountType,
          })),
        }
      }),
    }))
  }

  const handleEditMaxDiscount = () => setMaxDiscountModalVisible(true)

  const discountPercentage = (promotionCondition?.rewards?.[rewardIndex] as DiscountReward)?.discountValue || ''
  const isMaxDiscountExceeded =
    rewardType === RewardTypes.PERCENTAGE_DISCOUNT && discountPercentage > maxDiscountPercentage
  const canDeleteLayer = promotionCondition?.sequence > 1

  return {
    rewardOptions,
    rewardType,
    rewardValue,
    selectedDiscountType: rewardValue?.[0]?.discountType,
    isMaxDiscountExceeded,
    canDeleteLayer,
    handleSelectedRewardItem,
    handleDeleteLayer,
    handleEditMaxDiscount,
  }
}
